<template>
    <iframe
        v-if="!loading"
        class="animated fadeIn"
        :src="
            '//ikommportal.userecho.com/knowledge-bases/15-the-knowledge-base?sso_token=' +
                token
        "
        style="height: 6500px; width: 100%"
    />
</template>

<script>
import http from '@/http/http-common'

export default {
    data() {
        return {
            token: null,
            loading: true,
        }
    },
    created() {
        this.getToken()
    },

    methods: {
        getToken() {
            http.get('/services/userecho/getToken')
                .then(res => {
                    this.token = res.data.token
                })
                .finally(() => {
                    this.loading = false
                })
        },
    },
}
</script>

<style scoped>
iframe {
    border: none;
    outline: none;
}
</style>
